/** Updates Drupal page chrome after navigation within the React app. */
const BREADCRUMB_SELECTOR = ".block-system-breadcrumb-block ol.breadcrumb";
const PAGE_TITLE_SELECTOR = ".block-page-title-block h1";

export function updateDrupalBreadcrumbs(items = []) {
  const breadcrumb = document.querySelector(BREADCRUMB_SELECTOR);

  if (!breadcrumb) {
    return;
  }

  breadcrumb.innerHTML = `
    <li class="breadcrumb-item">
      <a href="/">Home</a>
    </li>
    <li class="breadcrumb-item">
      <a href="/plan-your-trip">Plan Your Trip</a>
    </li>
    ${items
      .map((item) =>
        item.href
          ? `<li class="breadcrumb-item"><a href="${item.href}">${item.label}</a></li>`
          : `<li class="breadcrumb-item">${item.label}</li>`
      )
      .join("")}
  `;
}

export function updateDrupalPageTitle(title) {
  // Preserve Drupal's site-name suffix for browser tabs and analytics page titles.
  const separator = document.title.indexOf(" | ");
  document.title = title + (separator === -1 ? "" : document.title.slice(separator));
  const pageTitle = document.querySelector(PAGE_TITLE_SELECTOR);

  if (!pageTitle) {
    return;
  }

  pageTitle.textContent = title;
}
